<template>
  <!-- 主内容区域 -->
  <main class="main-content doc-narrow-content">
    <!-- 欢迎区域 -->
    <section class="hero">
      <h1>API介绍</h1>
      <p>了解银企通™ API平台的核心功能、接口规范和使用方式，快速构建金融应用</p>
    </section>

    <!-- API列表 -->
    <section class="section" id="api-list">
      <div class="section-header">
        <h2>API列表</h2>
        <p>银企通™ API平台提供全面的API接口，满足不同业务场景需求</p>
      </div>

      <div class="card-grid">
        <div class="card">
          <div class="card-icon">
            <i class="fas fa-user-plus"></i>
          </div>
          <h3>客户管理</h3>
          <p>创建和管理企业客户信息，获取客户唯一标识</p>
          <a href="new-customer" class="card-link"
            >查看详情 <i class="fas fa-arrow-right"></i
          ></a>
        </div>

        <div class="card">
          <div class="card-icon">
            <i class="fas fa-link"></i>
          </div>
          <h3>签约管理</h3>
          <p>获取银行签约链接，管理企业银行账户授权</p>
          <a href="sign-url" class="card-link"
            >查看详情 <i class="fas fa-arrow-right"></i
          ></a>
        </div>

        <div class="card">
          <div class="card-icon">
            <i class="fas fa-exchange-alt"></i>
          </div>
          <h3>流水查询</h3>
          <p>获取企业银行账户交易流水，支持多条件筛选</p>
          <a href="transaction-query" class="card-link"
            >查看详情 <i class="fas fa-arrow-right"></i
          ></a>
        </div>
        <!--
        <div class="card">
          <div class="card-icon">
            <i class="fas fa-piggy-bank"></i>
          </div>
          <h3>账户查询</h3>
          <p>查询企业银行账户信息和实时余额数据</p>
          <a href="api-account.html" class="card-link"
            >查看详情 <i class="fas fa-arrow-right"></i
          ></a>
        </div>

        <div class="card">
          <div class="card-icon">
            <i class="fas fa-wallet"></i>
          </div>
          <h3>余额查询</h3>
          <p>获取企业银行账户每日余额和历史余额数据</p>
          <a href="api-balance.html" class="card-link"
            >查看详情 <i class="fas fa-arrow-right"></i
          ></a>
        </div>

        <div class="card">
          <div class="card-icon">
            <i class="fas fa-money-check-alt"></i>
          </div>
          <h3>支付服务</h3>
          <p>发起企业支付交易，支持多种支付方式和银行</p>
          <a href="api-payment.html" class="card-link"
            >查看详情 <i class="fas fa-arrow-right"></i
          ></a>
        </div> -->
      </div>
    </section>

    <!-- 接口规范 -->
    <section class="section" id="specification">
      <div class="section-header">
        <h2>接口规范</h2>
        <p>了解银企通™ API平台API的统一调用规范和请求响应格式</p>
      </div>

      <div class="api-reference">
        <div class="api-item">
          <div class="api-item-header">
            <span class="api-method method-post">POST</span>
            <span class="api-url">api/v2/{接口路径}</span>
          </div>
          <p class="api-description">
            所有API请求都使用HTTPS协议，请求和响应数据格式为JSON
          </p>

          <h4>请求头参数</h4>
          <div class="overflow-x-auto">
          <table class="param-table">
            <thead>
              <tr>
                <th>参数名</th>
                <th>类型</th>
                <th>必填</th>
                <th>描述</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Content-Type</td>
                <td>String</td>
                <td>是</td>
                <td>固定值: application/json</td>
              </tr>
              <tr>
                <td>x-app-id</td>
                <td>String</td>
                <td>是</td>
                <td>应用唯一标识App ID，从银企通™ API平台的应用与设置页面获取</td>
              </tr>
              <tr>
                <td>x-app-secret</td>
                <td>String</td>
                <td>是</td>
                <td>安全校验码API Key,从银企通™ API平台的应用与设置页面获取</td>
              </tr>
              <tr>
                <td>timestamp</td>
                <td>Long</td>
                <td>是</td>
                <td>请求时间戳，单位毫秒</td>
              </tr>
            </tbody>
          </table>
          </div>

          <h4>请求示例</h4>
          <div class="api-details">
            <pre>
{
    "requestId": "REQ202405210001",
    "customerCode": "CUST123456789",
    "bankCode": "ICBC",
    "startDate": "20240501",
    "endDate": "20240520",
    "page": 1,
    "pageSize": 20
}</pre
            >
          </div>

          <h4>响应示例</h4>
          <div class="api-details">
            <pre>
{
    "code": "200",
    "message": "success",
    "data": {
        "total": 45,
        "page": 1,
        "pageSize": 20,
        "items": [...]
    },
    "requestId": "REQ202405210001"
}</pre
            >
          </div>
        </div>
      </div>

      <div class="feature-list">
        <div class="feature-item">
          <div class="feature-icon">
            <i class="fas fa-shield-alt"></i>
          </div>
          <div class="feature-content">
            <h3>安全认证</h3>
            <p>
              所有API请求都需要进行身份验证，使用AppID和API Key确保请求安全。
            </p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-icon">
            <i class="fas fa-bolt"></i>
          </div>
          <div class="feature-content">
            <h3>高性能</h3>
            <p>
              API接口设计支持高并发请求，响应时间通常在100ms以内，满足企业级应用性能要求。
            </p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-icon">
            <i class="fas fa-sync-alt"></i>
          </div>
          <div class="feature-content">
            <h3>实时数据</h3>
            <p>银行流水和账户余额数据实时同步，确保数据的及时性和准确性。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据字典 -->
   <!-- <section class="section" id="data-dictionary">
      <div class="section-header">
        <h2>数据字典</h2>
        <p>了解API接口中常用的数据字段定义和枚举值</p>
      </div>

       <h3>银行编码</h3>
      <table class="param-table">
        <thead>
          <tr>
            <th>银行编码</th>
            <th>银行名称</th>
            <th>支持功能</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ICBC</td>
            <td>中国工商银行</td>
            <td>流水查询、余额查询、支付</td>
          </tr>
          <tr>
            <td>ABC</td>
            <td>中国农业银行</td>
            <td>流水查询、余额查询</td>
          </tr>
          <tr>
            <td>BOC</td>
            <td>中国银行</td>
            <td>流水查询、余额查询、支付</td>
          </tr>
          <tr>
            <td>CCB</td>
            <td>中国建设银行</td>
            <td>流水查询、余额查询</td>
          </tr>
          <tr>
            <td>CMB</td>
            <td>招商银行</td>
            <td>流水查询、余额查询、支付</td>
          </tr>
        </tbody>
      </table> 

      <h3>交易类型</h3>
      <table class="param-table">
        <thead>
          <tr>
            <th>类型编码</th>
            <th>类型名称</th>
            <th>描述</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>R</td>
            <td>收入</td>
            <td>账户资金流入交易</td>
          </tr>
          <tr>
            <td>P</td>
            <td>支出</td>
            <td>账户资金流出交易</td>
          </tr>
          
        </tbody>
      </table>

      <h3>货币类型</h3>
      <p>
        银行接口中使用的货币类型，包括人民币（CNY）、美元（USD）、港币（HKD）、欧元（EUR）和日元（JPY）。主要参考ISO-4217标准。
        <br>以下是部分币种示例：
      </p>
      <table class="param-table">
        <thead>
          <tr>
            <th>货币编码</th>
            <th>货币名称</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>CNY</td>
            <td>人民币</td>
          </tr>
          <tr>
            <td>USD</td>
            <td>美元</td>
          </tr>
          <tr>
            <td>HKD</td>
            <td>港币</td>
          </tr>
          <tr>
            <td>EUR</td>
            <td>欧元</td>
          </tr>
          <tr>
            <td>JPY</td>
            <td>日元</td>
          </tr>
        </tbody>
      </table>
    </section>-->

    <!-- 下一步 -->
    <section class="section">
      <div class="section-header">
        <h2>下一步</h2>
        <p>开始使用银企通™ API平台的API接口构建您的应用</p>
      </div>

      <div class="card-grid">
        <div class="card">
          <div class="card-icon">
            <i class="fas fa-book"></i>
          </div>
          <h3>查看详细文档</h3>
          <p>详细了解每个API接口的参数、返回值和调用示例。</p>
          <a href="new-customer" class="card-link"
            >查看文档 <i class="fas fa-arrow-right"></i
          ></a>
        </div>

        <!--  <div class="card">
          <div class="card-icon">
            <i class="fas fa-download"></i>
          </div>
          <h3>下载SDK</h3>
          <p>获取各种语言的SDK，加速开发集成过程。</p>
          <a href="sdk.html" class="card-link"
            >下载SDK <i class="fas fa-arrow-right"></i
          ></a>
        </div>-->

        <!-- <div class="card">
          <div class="card-icon">
            <i class="fas fa-headset"></i>
          </div>
          <h3>联系客服</h3>
          <p>获取技术支持或申请切换到生产环境。</p>
          <a href="#" class="card-link">联系客服 <i class="fas fa-arrow-right"></i></a>
        </div> -->
      </div>
    </section>
  </main>
</template>

<style scoped>
.hero {
  background: linear-gradient(120deg, #7486f1, #955bea);
  border-radius: 12px;
  padding: 2.5rem;
  color: white;
  margin-bottom: 2rem;
}

.hero h1 {
  font-size: 2.25rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.hero p {
  font-size: 1.1rem;
  max-width: 700px;
  margin-bottom: 1.5rem;
  opacity: 0.9;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.card {
  background-color: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background-color: rgba(58, 109, 248, 0.1);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.card h3 {
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
  color: var(--text-primary);
}

.card p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.card-link {
  color: var(--primary);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
}

.card-link i {
  margin-left: 0.5rem;
  transition: transform 0.2s;
}

.card-link:hover i {
  transform: translateX(3px);
}

.section {
  margin-bottom: 3rem;
}

.section-header {
  margin-bottom: 1.5rem;
}

.section-header h2 {
  font-size: 1.5rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.section-header p {
  color: var(--text-secondary);
}

.api-reference {
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.api-item {
  border-bottom: 1px solid var(--border);
  padding: 1.5rem;
}

.api-item:last-child {
  border-bottom: none;
}

.api-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.api-method {
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-right: 0.75rem;
}

.method-get {
  background-color: rgba(71, 184, 129, 0.1);
  color: #47b881;
}

.method-post {
  background-color: rgba(58, 109, 248, 0.1);
  color: var(--primary);
}

.api-url {
  font-size: 0.9rem;
  color: var(--text-primary);
}

.api-description {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.api-details {
  background-color: var(--code-bg);
  color: var(--code-color);
  border-radius: 8px;
  padding: 1rem;
  font-size: 0.85rem;
  overflow-x: auto;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.api-details pre {
  margin: 0;
  white-space: pre-wrap;
}

.param-table {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
}

.param-table th,
.param-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--border);
}

.param-table th {
  background-color: var(--secondary);
  font-weight: 600;
}

/* API介绍特定样式 */
.feature-list {
  margin: 1.5rem 0;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.feature-icon {
  background-color: rgba(58, 109, 248, 0.1);
  color: var(--primary);
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
}

.feature-content {
  flex: 1;
}

.feature-content h3 {
  margin-bottom: 0.5rem;
  color: var(--text-primary);
}

.feature-content p {
  color: var(--text-secondary);
}

.architecture-diagram {
  background-color: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin: 2rem 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.architecture-diagram img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.diagram-caption {
  margin-top: 1rem;
  color: var(--text-secondary);
  font-style: italic;
}

@media (max-width: 768px) {
  .feature-item {
    flex-direction: column;
  }

  .feature-icon {
    margin-bottom: 0.5rem;
    margin-right: 0;
  }
}

/* 子菜单样式 */
.sidebar-links .sidebar-links {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.sidebar-links .sidebar-links a {
  font-size: 0.85rem;
  padding: 0.25rem 1.5rem;
}

.sidebar-links .sidebar-links a:hover {
  background-color: rgba(58, 109, 248, 0.05);
}

.sidebar-links .sidebar-links a.active {
  background-color: rgba(58, 109, 248, 0.1);
}

.has-submenu > a {
  display: flex;
  align-items: center;
}

.submenu-icon {
  transition: transform 0.3s ease;
  font-size: 0.75rem;
  margin-left: auto;
}

.submenu-icon.rotated {
  transform: rotate(180deg);
}

.submenu {
  transition: all 0.3s ease;
}
</style>

<script setup lang="ts">
import { onMounted } from "vue";
import { useCodeHighlight } from "@/composables/useCodeHighlight";

// 使用代码高亮功能
useCodeHighlight(".api-details pre");
</script>
